module.exports = require('./_hide');



// WEBPACK FOOTER //
// webpack:///node_modules/core-js/library/modules/_redefine.js